<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v13A1.5 1.5 0 003.5 18h17a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0020.5 2zM20 16H4V4h16zM21 20H3a1 1 0 000 2h18a1 1 0 000-2z"/></svg>